import React, { createContext, useState, useEffect } from 'react';

// Create a context
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check for token in localStorage on app load
  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      const name = localStorage.getItem('name');
      const email = localStorage.getItem('email');
      setIsAuthenticated(true);
      setUser({ name, email });
    }
    setLoading(false);
  }, []);

  // ✅ Login: store both accessToken + refreshToken
  const login = (
    user_id,
    accessToken,
    refreshToken,
    name,
    email,
    companyname,
    address1,
    address2,
    city,
    zipCode,
    phone
  ) => {
    localStorage.setItem('user_id', user_id);
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('name', name);
    localStorage.setItem('email', email);
    localStorage.setItem('companyname', companyname);
    localStorage.setItem('address1', address1);
    localStorage.setItem('address2', address2);
    localStorage.setItem('city', city);
    localStorage.setItem('zipcode', zipCode);
    localStorage.setItem('companyphone', phone);
    setIsAuthenticated(true);
    setUser({ name, email });
  };

  // ✅ Logout: clear everything
  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('name');
    localStorage.removeItem('email');
    localStorage.removeItem('user_id');
    localStorage.removeItem('companyname');
    localStorage.removeItem('address1');
    localStorage.removeItem('address2');
    localStorage.removeItem('city');
    localStorage.removeItem('zipcode');
    localStorage.removeItem('companyphone');
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
